import "./styles.css";

const GoogleLoginButton = ({ onClick }) => (
  <button className="google-btn" onClick={onClick}>
    <span className="google-icon">
      <svg width="22" height="22" viewBox="0 0 48 48">
        <g>
          <path fill="#4285F4" d="M24 9.5c3.5 0 6.7 1.2 9.2 3.4l6.8-6.8C35.5 2.2 30.1 0 24 0 14.7 0 6.4 5.6 2.2 13.7l8.3 6.4C12.6 13.1 17.8 9.5 24 9.5z"/>
          <path fill="#34A853" d="M46.1 24.6c0-1.5-.1-2.9-.3-4.3H24v8.1h12.5c-.5 2.5-2 4.6-4.2 6.1v5h6.8c4-3.7 6.3-9.1 6.3-14.9z"/>
          <path fill="#FBBC05" d="M10.5 28.2c-1-2.5-1-5.3 0-7.8v-5.1H2.2C-.7 18.1-.7 29.9 2.2 34.3l8.3-6.1z"/>
          <path fill="#EA4335" d="M24 47.5c6.1 0 11.4-2 15.1-5.5l-6.8-5.1c-2 1.4-4.6 2.3-8.3 2.3-6.2 0-11.4-4.1-13.2-9.6l-8.3 6.1C6.4 42.4 14.7 47.5 24 47.5z"/>
          <path fill="none" d="M0 0h48v48H0z"/>
        </g>
      </svg>
    </span>
    <span className="google-btn-text">Zaloguj przez Google</span>
  </button>
);

export default GoogleLoginButton;
